import script from "./FormInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=3f8cb2cc&lang=less"

const __exports__ = script;

export default __exports__